import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function F() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();

    const IMGS = [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125102235/6_1.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125112279/6_1_M.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125128381/6_2.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125141139/6_2_M.jpg',
        },
    ];

    return (
        <div className={`sp-175w-F sp-175w-common ${css['sp-175w-F']}`}>
            <div className="info">
                <p className="subtitle">{t('F_subtitle')}</p>
                <p className="title">{t('F_title')}</p>
                <p className="desc">{t('F_desc')}</p>
            </div>
            <ul className="imgs">
                {[1, 2]?.map((img: any, k: number) => (
                    <li className="img" key={k}>
                        <EFPicture src={IMGS[k].pc} srcPad={IMGS[k].h5} srcMobile={IMGS[k].h5} alt={t('F_title')} />
                    </li>
                ))}
            </ul>
            <p className="tip">{t('F_tip')}</p>
        </div>
    );
}
